import React from 'react';

const WineGlassUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<path
				fill='#2d2d2d'
				d='M10.25 37.5v3h9v-3h-3v-4.71c2.58-.675 4.5-3 4.5-5.79V15c0-.825-.675-1.5-1.5-1.5h-9c-.825 0-1.5.675-1.5 1.5v12c0 2.79 1.92 5.115 4.5 5.79v4.71h-3zm1.5-10.5V16.5h6V18h-4.5v3h4.5v6c0 1.65-1.35 3-3 3s-3-1.35-3-3zM38.135 19.2c-1.11-1.965-2.385-4.185-2.385-6.165V3c0-1.65-1.35-3-3-3h-3c-1.65 0-3 1.35-3 3v10.035c0 1.98-1.275 4.2-2.385 6.165-1.095 1.89-2.115 3.675-2.115 5.37V39c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V24.57c0-1.695-1.02-3.48-2.115-5.37zm-8.385-6.165V7.44h3v5.595c0 1.485.42 2.91 1.02 4.26-.51.39-1.395.705-2.52.705-1.185 0-2.025-.345-2.505-.705.585-1.365 1.005-2.775 1.005-4.26zM32.75 3v1.44h-3V3h3zm4.5 34.5h-12V24.57c0-.9.87-2.415 1.71-3.885l.405-.72c1.065.66 2.43 1.035 3.885 1.035 1.47 0 2.835-.375 3.885-1.02.135.24.27.48.405.705.84 1.47 1.71 2.985 1.71 3.885V37.5z'
			></path>
			<path
				fill='#2d2d2d'
				d='M34.25 25.5h-6c-.825 0-1.5.675-1.5 1.5v4.5c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5V27c0-.825-.675-1.5-1.5-1.5zm-1.5 4.5h-3v-1.5h3V30zM38.75 45h-27v3h27v-3z'
			></path>
		</svg>
	);
};

export default WineGlassUnderline;
